import React from 'react';
import { Checkbox, CheckboxGroup } from '@finn-no/troika-react-checkbox';

import { ApiQueryParams, CheckboxMap, Facet } from '../../../interfaces';

export interface CheckboxStateProps {
    id: string;
    label: string;
    facetList: Facet[];
    displayValues: Record<string, string | React.ReactNode>;
    checkboxValues: CheckboxMap;
    checkBoxClickMapper?: (checkBoxValue: string) => Record<string, unknown>;
    hideLabel?: boolean;
}

export interface CheckboxDispatchProps {
    checkBoxClick: (checkBoxValue: string | Record<string, unknown>) => void;
    fetchResults: (queryParams?: ApiQueryParams) => void;
}

type CheckboxProps = CheckboxDispatchProps & CheckboxStateProps;

export const CheckboxFilter: React.FC<CheckboxProps> = ({
    id,
    label,
    facetList,
    displayValues,
    checkboxValues,
    checkBoxClickMapper,
    checkBoxClick,
    fetchResults,
    hideLabel = false,
}): React.ReactElement<CheckboxProps> => {
    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (checkBoxClickMapper) {
            checkBoxClick(checkBoxClickMapper(event.target.value));
        } else {
            checkBoxClick(event.target.value);
        }
        fetchResults();
    };

    const isDev = process.env.NODE_ENV === 'development';

    const createDisplayValue = (facet: Facet): string | React.ReactNode => {
        const displayValue = displayValues[facet.value];
        if (typeof displayValue === 'string') {
            return `${displayValue}${facet.count !== undefined && facet.count !== null ? ` (${facet.count})` : ''}`;
        }
        return (
            <div>
                {displayValues[facet.value]}
                {facet.count !== undefined && facet.count !== null && <span>({facet.count})</span>}
            </div>
        );
    };

    return (
        <div className={hideLabel ? 'checkbox-filter__hide-label u-mv16' : 'u-mv16'}>
            <CheckboxGroup data-testid={`CheckboxFilterGroup-${id}`} label={label} value={Object.keys(checkboxValues)} onChange={onChange}>
                {facetList &&
                    facetList.reduce((checkboxList: React.ReactElement[], facet): React.ReactElement[] => {
                        if (displayValues[facet.value] || isDev) {
                            const checkBox = (
                                <Checkbox
                                    data-testid={`CheckboxFilter-${id}-${facet.value}`}
                                    key={facet.value}
                                    label={createDisplayValue(facet)}
                                    value={facet.value}
                                    name={id}
                                />
                            );
                            return [...checkboxList, checkBox];
                        }

                        return checkboxList;
                    }, [])}
            </CheckboxGroup>
        </div>
    );
};
